"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

const LINKS = [
  { href: "/", label: "홈" },
  { href: "/archive", label: "아카이브" },
  { href: "/character", label: "캐릭터" },
  { href: "/history", label: "대화 기록" },
  { href: "/?feed=1", label: "먹이주기" },
  { href: "/memories", label: "기억" },
  { href: "/settings", label: "설정" },
];

export function AppShell({ subtitle, role, children }: { subtitle: string; role?: string; children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();
  const archive = pathname.startsWith("/archive");
  useEffect(() => setOpen(false), [pathname]);

  return (
    <div className="studio">
      <div className="phone">
        <div className="sky" />
        {!archive && (
          <header className="topbar">
            <button className="icon-btn" aria-label="메뉴 열기" aria-expanded={open} onClick={() => setOpen(true)}>
              ☰
            </button>
            <div className="brand">
              <div className="word">LUMI</div>
              <p className="sub">{subtitle}</p>
            </div>
            <Link className="icon-btn" href="/archive" aria-label="아카이브">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M7 4.5h10a1 1 0 0 1 1 1V20l-6-3.2L6 20V5.5a1 1 0 0 1 1-1Z" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
              </svg>
            </Link>
          </header>
        )}
        {open && (
          <>
            <button className="scrim" aria-label="메뉴 닫기" onClick={() => setOpen(false)} />
            <nav className="drawer" aria-label="주요 메뉴">
              <div className="brand-row">
                <div className="word">LUMI</div>
                <button className="close" aria-label="메뉴 닫기" onClick={() => setOpen(false)}>
                  ×
                </button>
              </div>
              {[...LINKS, ...(role === "admin" ? [{ href: "/admin", label: "운영" }] : [])].map((link) => (
                <Link key={link.label} href={link.href} aria-current={pathname === link.href ? "page" : undefined}>
                  {link.label}
                </Link>
              ))}
              <p className="tagline">캐릭터와 함께 쌓는 나의 덕질</p>
            </nav>
          </>
        )}
        <div className="stage">{children}</div>
      </div>
    </div>
  );
}

export function PhoneFrame({ children, center = false, wordmark = false }: { children: React.ReactNode; center?: boolean; wordmark?: boolean }) {
  return (
    <div className="studio">
      <div className="phone">
        <div className="sky" />
        {wordmark && <div className="word login-mark">LUMI</div>}
        <div className={center ? "stage page-pad center" : "stage page-pad"}>{children}</div>
      </div>
    </div>
  );
}

export function LumiFace({ className, label = "루미" }: { className?: string; label?: string }) {
  return <img className={className} src="/lumi-character.png" alt={label} />;
}

export function LumiCharacter({ onReact }: { onReact?: () => void }) {
  const [active, setActive] = useState(false);
  return (
    <button
      type="button"
      className={active ? "character react" : "character"}
      aria-label="캐릭터를 터치해 반응 보기"
      onClick={() => {
        setActive(true);
        onReact?.();
        window.setTimeout(() => setActive(false), 600);
      }}
    >
      <LumiFace label="" />
    </button>
  );
}
